export const PARTICIPANT_FLOW_PATTERNS = [
  '/participante/login',
  '/participante/senha',
  '/participante/cadastro',
  '/participante/recuperar',
  '/recSenha',
  '/participante/page',
  '/participante/page/resultado/:idResultado',
  '/res/:idTurma',
  '/ead/:idTurma',
];

export function isParticipantFlowPath(pathname = '') {
  const normalized = String(pathname || '').replace(/\/+$/, '') || '/';

  if (/^\/participante\/(login|senha|cadastro|recuperar|page)$/.test(normalized)) {
    return true;
  }

  return (
    normalized === '/recSenha' ||
    /^\/participante\/page\/resultado\/[^/?#]+$/.test(normalized) ||
    /^\/(res|ead)\/[^/?#]+$/.test(normalized)
  );
}
